import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { streamContext, useStreamStateMonitor, useStreamStore, } from '#pplx/frontend/stream/stream.js';
import React, { useLayoutEffect } from 'react';
const StreamStateMonitor = () => {
    useStreamStateMonitor();
    return null;
};
export const StreamStateProvider = React.memo(function StreamStateProvider({ children }) {
    return (_jsxs(streamContext.Provider, { children: [_jsx(StreamStateMonitor, {}), children] }));
});
export const MiddlewareRegistry = React.memo(function MiddlewareRegistry({ middlewares }) {
    const store = useStreamStore();
    useLayoutEffect(() => {
        store.getState().actions.setMiddlewares(middlewares);
    }, [middlewares, store]);
    return null;
});
//# sourceMappingURL=StreamComponents.js.map